import { z } from 'zod'

export const AGENTMCP_ROOT_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpRootResponseSchema = z.object({
  name: z.string(),
  version: z.string(),
  description: z.string(),
  endpoints: z.record(z.string()),
  auth: z.object({
    bootstrap: z.array(z.string()),
    session_contract: z.string(),
  }),
}).passthrough()

export type AgentmcpRootResponse = z.infer<typeof agentmcpRootResponseSchema>
